// const drd = require("1dr-utils/helpers/docReadyDeferred");
import drd from "1dr-utils/helpers/docReadyDeferred";

let APP = window.APP || {};
APP.polyfillsReady = new drd();

// Element.after polyfill for IE11, adds 'after' eg element.after( newElement )
//from: https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/after()/after().md
(function (arr) {
  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, "after")) {
      return;
    }
    Object.defineProperty(item, "after", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function after() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(
            isNode ? argItem : document.createTextNode(String(argItem)),
          );
        });

        this.parentNode.insertBefore(docFrag, this.nextSibling);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Remove polyfill
// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (Object.prototype.hasOwnProperty.call(item, "remove")) {
      return;
    }
    Object.defineProperty(item, "remove", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null) this.parentNode.removeChild(this);
      },
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

// Element.matches polyfill
// See: https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
if (!Element.prototype.matches) {
  Element.prototype.matches =
    Element.prototype.matchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector ||
    Element.prototype.oMatchesSelector ||
    Element.prototype.webkitMatchesSelector ||
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i = matches.length;
      while (--i >= 0 && matches.item(i) !== this) {}
      return i > -1;
    };
}

// If anything needs to check polyfills, use APP.polyfillsReady.q( callback );
// For new browsers, it'll run immediately. For IE11, it'll wait for the poyfill
// JS to load before executing. Hooray!

var needsFormData =
  "FormData" in window
    ? "entries" in FormData.prototype
      ? false
      : true
    : true;
var needsPromise = !("Promise" in window);

if (!needsFormData && !needsPromise) {
  // Native Fetch and Promise Support:
  APP.polyfillsReady.run();
} else {
  console.log("Loading polyfills...");
  loadjs([APP.config.assetsPath + "polyfills.min.js"], "polyfills");
  loadjs.ready("polyfills", {
    success: function () {
      console.log("Success");
      APP.polyfillsReady.run();
    },
  });
}
